import plugin from './dist/vue-circle-slider.common.js'
export default plugin
export * from './dist/vue-circle-slider.common.js'
import './dist/vue-circle-slider.css'



//////////////////
// WEBPACK FOOTER
// ./~/vue-circle-slider/index.js
// module id = 486
// module chunks = 0